import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Wrench } from 'lucide-react';

const MaintenanceBanner = () => {
  const [maintenance, setMaintenance] = React.useState(null);
  const { user } = useAuth();

  React.useEffect(() => {
    const check = () => {
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/platform/maintenance`)
        .then(r => r.json())
        .then(d => setMaintenance(d.enabled ? d : null))
        .catch(() => {});
    };
    check();
    const interval = setInterval(check, 30000);
    return () => clearInterval(interval);
  }, []);

  if (!maintenance) return null;
  return (
    <div className="bg-amber-500 text-black px-4 py-2 text-center text-sm font-medium no-print" data-testid="maintenance-banner">
      <Wrench size={14} className="inline mr-2" />
      {maintenance.message || 'MOSAIC is undergoing maintenance. Your data is safe.'}
      {maintenance.estimated_return && (
        <span className="ml-2 opacity-75">| Back by: {new Date(maintenance.estimated_return).toLocaleString()}</span>
      )}
      {user?.role === 'super_admin' && (
        <Link to="/superadmin" className="ml-3 underline font-bold">Manage</Link>
      )}
    </div>
  );
};

export default MaintenanceBanner;
